var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"carousel"},[_c('el-carousel',{attrs:{"height":"31.25vw","interval":5000,"arrow":"always"}},_vm._l((_vm.carousel),function(item){return _c('el-carousel-item',{key:item},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":item,"fit":"scale-down"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }